import React, { useState } from 'react';
import { Header } from './components/Header';
import { BrunchBooking } from './components/BrunchBooking';
import { JobsCTA } from './components/JobsCTA';
import { SocialFeed } from './components/SocialFeed';
import { Footer } from './components/Footer';
import { Navigation, ServiceType } from './components/Navigation';
import { X, Mail } from 'lucide-react';
export function App() {
  const [showUnavailable, setShowUnavailable] = useState(false);
  return <div className="min-h-screen w-full bg-[#FFF8F0] text-[#1A1A1A] font-sans selection:bg-[#C5A55A] selection:text-white flex flex-col" data-id="element-0">
      <Navigation onOrderClick={() => setShowUnavailable(true)} data-id="element-1" />

      <main className="flex-grow flex flex-col items-center w-full" data-id="element-2">
        <Header data-id="element-3" />

        <div className="w-full max-w-5xl mx-auto space-y-12 md:space-y-24 pb-20" data-id="element-4">
          <BrunchBooking data-id="element-5" />
          <div className="w-full h-px bg-[#C5A55A]/20 max-w-xs mx-auto" data-id="element-6" />
          <JobsCTA data-id="element-7" />
          <div className="w-full h-px bg-[#C5A55A]/20 max-w-xs mx-auto" data-id="element-8" />
          <SocialFeed data-id="element-9" />
        </div>
      </main>

      <Footer data-id="element-10" />

      {showUnavailable && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200" onMouseDown={e => e.target === e.currentTarget && setShowUnavailable(false)} data-id="element-11">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 text-center animate-in zoom-in-95 duration-200" data-id="element-12">
            <div className="w-14 h-14 bg-[#C5A55A]/10 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-13">
              <Mail className="w-7 h-7 text-[#C5A55A]" data-id="element-14" />
            </div>
            <h3 className="text-xl font-serif text-[#1A1A1A] mb-2" data-id="element-15">
              Inte tillgängligt just nu
            </h3>
            <p className="text-sm text-[#1A1A1A]/65 leading-relaxed mb-6" data-id="element-16">
              Onlinebeställning är inte tillgänglig för tillfället.
              Förfrågningar kan mejlas direkt till oss på{' '}
              <a href="mailto:info@topnotchbakery.se" className="text-[#C5A55A] hover:text-[#b8963f] underline underline-offset-2 transition-colors font-medium" data-id="element-17">
                info@topnotchbakery.se
              </a>
            </p>
            <button onClick={() => setShowUnavailable(false)} className="w-full py-2.5 px-4 rounded-lg border border-[#C5A55A]/30 text-sm font-medium text-[#1A1A1A]/70 hover:bg-[#FFF8F0] transition-colors" data-id="element-18">
              Stäng
            </button>
          </div>
        </div>}
    </div>;
}